import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-476bb08e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("文件格式：jpg、png文件大小不超过5M")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("文件格式：mp3文件大小不超过10M")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("文件格式：视频文件大小不超过50M")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_FormDialog = _resolveComponent("FormDialog")!

  return (_openBlock(), _createBlock(_component_FormDialog, {
    ref: "formDialogRefs",
    title: _ctx.editFormData.operateType=='restart'?'重新激活': '追加描述信息',
    width: "660px",
    labelWidth: "120px",
    formData: _ctx.editFormData,
    rules: _ctx.reRules,
    showErrorToast: false,
    validateOnRuleChange: false,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.visibleRef) = $event)),
    saveForm: _ctx.saveFormHandle
  }, {
    default: _withCtx(() => [
      (_ctx.editFormData.operateType=='restart')
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "运单号",
            prop: "billCode"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "",
                disabled: "",
                modelValue: _ctx.editFormData.billCode,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editFormData.billCode) = $event)),
                modelModifiers: { trim: true }
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.editFormData.operateType=='restart')
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "售后类型",
            prop: "orderType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                placeholder: "",
                disabled: "",
                modelValue: _ctx.editFormData.orderTypeName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editFormData.orderTypeName) = $event)),
                modelModifiers: { trim: true }
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_form_item, {
        label: "问题描述",
        prop: "description"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "textarea",
            maxlength: "100",
            rows: "3",
            resize: "none",
            "show-word-limit": "",
            placeholder: "请输入问题描述",
            modelValue: _ctx.editFormData.description,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editFormData.description) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "图片上传",
        prop: "pictureList"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_UploadImage, {
            appId: _ctx.ZFS.SDAppid,
            accept: "image/*",
            limit: 4,
            originFileName: _ctx.editFormData.pictureList,
            "onUpdate:originFileName": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editFormData.pictureList) = $event))
          }, {
            outerContanier: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }, 8, ["appId", "originFileName"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "音频上传",
        prop: "audioList"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_UploadImage, {
            appId: _ctx.ZFS.SDAppid,
            accept: "audio/*",
            limit: 3,
            maxFileSize: 10,
            originFileName: _ctx.editFormData.audioList,
            "onUpdate:originFileName": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editFormData.audioList) = $event))
          }, {
            outerContanier: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }, 8, ["appId", "originFileName"])
        ]),
        _: 1
      }),
      (_ctx.editFormData.operateType=='append')
        ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            label: "视频上传",
            prop: "videoList"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UploadImage, {
                appId: _ctx.ZFS.SDAppid,
                accept: "video/*",
                limit: 3,
                maxFileSize: 50,
                originFileName: _ctx.editFormData.videoList,
                "onUpdate:originFileName": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editFormData.videoList) = $event))
              }, {
                outerContanier: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["appId", "originFileName"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["title", "formData", "rules", "visible", "saveForm"]))
}